import { MDCRipple } from '@material/ripple/dist/mdc.ripple';

/**
 * Init Ripple Surfaces.
 *
 * @link https://github.com/material-components/material-components-web/tree/v0.28.0/master/packages/mdc-ripple
 *
 * @since 0.0.1
 * @return {void} 
 */
export function initMDCRipple(element, timeout = 0) {
	if (element) {
		setTimeout(() => {
			MDCRipple.attachTo(element);
		}, timeout);
	}
}

export function initMDCRipples(parent, timeout = 0) {
	parent = parent ? parent : document;
	setTimeout(() => {
		const surfaces = parent.querySelectorAll('.mdc-ripple-surface:not(.pbsm-ripple-surface--no-js)');
		surfaces.forEach((surface, i) => {
			initMDCRipple(surface, timeout);
		});
	}, timeout);
}